/**
 * 着地ページ・流入元を sessionStorage に記録し、
 * Powerful Form Builder 等の hidden 項目へ値をセットする
 */
(function() {
  // 1. 初回訪問時のみ記録
  if (!sessionStorage.getItem('landing_page')) {
    sessionStorage.setItem('landing_page', location.pathname + location.search);
    sessionStorage.setItem('referrer', document.referrer);

    var ref = document.referrer;
    var isAd = /[?&](gclid|yclid|utm_source|fbclid|msclkid)=/.test(location.href);
    var isSearch = /google\.|yahoo\.|bing\.|duckduckgo\./.test(ref);
    var source = isSearch && !isAd ? '自然検索'
               : isAd ? '広告'
               : ref === '' ? '直接流入'
               : '参照サイト';
    sessionStorage.setItem('traffic_source', source);
  }

  // 2. Powerful Form Builder の hidden フィールドへピンポイント代入
  function fillTrackingFields() {
    var sourceVal = sessionStorage.getItem('traffic_source') || '不明';
    var landingVal = sessionStorage.getItem('landing_page') || '不明';

    // id="hidden-1" および name="hidden-1" に代入
    document.querySelectorAll('#hidden-1, input[name="hidden-1"]').forEach(function(el) {
      el.value = sourceVal;
    });

    // id="hidden-2" および name="hidden-2" に代入
    document.querySelectorAll('#hidden-2, input[name="hidden-2"]').forEach(function(el) {
      el.value = landingVal;
    });
  }

  function startWatching() {
    fillTrackingFields();

    // 非同期で描画されるフォームを常に監視
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function() {
        fillTrackingFields();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    // 送信ボタンが押された直前にも強制的に値を再セット
    document.addEventListener('submit', fillTrackingFields, true);
    document.addEventListener('click', function(e) {
      if (e.target && (e.target.type === 'submit' || e.target.closest('button[type="submit"]'))) {
        fillTrackingFields();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWatching);
  } else {
    startWatching();
  }
})();
